"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnsListByReportMeasures = getColumnsListByReportMeasures;
const dbTableCampaign_1 = require("../../reporterDb/dbTableCampaign");
const measuresInterDependency_1 = require("../measuresInterDependency");
const cohortedReportColumns_1 = require("./cohortedReportColumns");
const columnTypes_1 = require("./columnTypes");
const resolveSalesMeasureExportLabel_1 = require("./resolveSalesMeasureExportLabel");
function getColumnsListByReportMeasures(orderedColumns, splits = [], granularity, hiddenColumns) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    let splitsFiltered = [...splits];
    const indexOfGranularity = splits.map((s) => s.id).indexOf("GRANULARITY");
    if (indexOfGranularity > -1 && granularity === "ALL") {
        //granularity will not be apllied as a split in case of 'ALL' value, in reporter
        splitsFiltered = splits
            .slice(0, indexOfGranularity)
            .concat(splits.slice(indexOfGranularity + 1));
    }
    const splitColumns = splitsFiltered.map((split) => ({
        label: split.name,
        id: split.id,
        columnType: columnTypes_1.ColumnTypes.Dimension,
    }));
    let measureColumns = [];
    const { columnsWithDeps, idsToQueryButHideInUI } = (0, measuresInterDependency_1.getVisibleColumnsWithDependencies)(orderedColumns, hiddenColumns);
    for (let column of columnsWithDeps) {
        const isHidden = idsToQueryButHideInUI.has(column.id);
        if ((0, cohortedReportColumns_1.isCohortableColumnType)(column.columnType) || (0, cohortedReportColumns_1.isCohortedAppMeasureV2)(column)) {
            const cohortedColumn = column;
            const cohortedResultColumns = (_a = cohortedColumn.cohorts) === null || _a === void 0 ? void 0 : _a.map((cohort) => {
                var _a, _b, _c, _d, _e;
                const id = (0, cohortedReportColumns_1.getCohortColumnId)({ dataMappingId: ((_a = cohortedColumn.dataMappingId) !== null && _a !== void 0 ? _a : cohortedColumn.id), cohort });
                const { label } = (0, cohortedReportColumns_1.getCohortColumnLabels)({
                    cohort,
                    eventLabel: cohortedColumn.label ||
                        (0, resolveSalesMeasureExportLabel_1.resolveSalesMeasureExportLabel)(cohortedColumn) ||
                        ((_e = (_c = (_b = dbTableCampaign_1.EVENTS_LABELED[cohortedColumn.eventId]) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : (_d = dbTableCampaign_1.METRICS_LABELED[cohortedColumn.eventId]) === null || _d === void 0 ? void 0 : _d.label) !== null && _e !== void 0 ? _e : cohortedColumn.id),
                });
                return {
                    id,
                    label,
                    columnType: cohortedColumn.columnType,
                    eventId: cohortedColumn.eventId,
                    cohort,
                    isHidden
                };
            });
            if (cohortedResultColumns === null || cohortedResultColumns === void 0 ? void 0 : cohortedResultColumns.length) {
                measureColumns.push(...cohortedResultColumns);
            }
        }
        else {
            measureColumns.push({
                label: (_g = (_f = (_e = (_c = (_b = dbTableCampaign_1.EVENTS_LABELED[column.id]) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : (_d = dbTableCampaign_1.METRICS_LABELED[column.id]) === null || _d === void 0 ? void 0 : _d.label) !== null && _e !== void 0 ? _e : column.label) !== null && _f !== void 0 ? _f : (0, resolveSalesMeasureExportLabel_1.resolveSalesMeasureExportLabel)(column)) !== null && _g !== void 0 ? _g : column.id,
                id: (_h = column.dataMappingId) !== null && _h !== void 0 ? _h : column.id,
                columnType: column.columnType,
                eventId: column.eventId ||
                    column.value ||
                    column.eventId ||
                    column.eventId,
                isHidden
            });
        }
    }
    const columns = [...splitColumns, ...measureColumns];
    return columns;
}
